import React from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { useStyles } from 'features/app/components/Modal/styles';

type ModalProps = {
  closeButton?: boolean;
  rootClass?: string;
  paperClass?: string;
  dialogContentClass?: string;
  children: React.ReactNode;
  onClose: () => void;
  title?: string;
  open: boolean;
};

const Modal: React.FC<ModalProps> = ({
  closeButton,
  children,
  onClose,
  title,
  open,
  dialogContentClass = '',
  paperClass = '',
  rootClass = '',
}) => {
  const classes = useStyles();

  const dialogClasses = React.useMemo(
    () => ({
      root: `${classes.dialog} ${rootClass}`,
      paper: `${classes.paper} ${paperClass}`,
    }),
    [classes.dialog, classes.paper, paperClass, rootClass]
  );

  return (
    <Dialog classes={dialogClasses} onClose={onClose} open={open}>
      {title && (
        <DialogTitle className={classes.dialogTitle} disableTypography>
          <Typography className={classes.dialogHeading} variant="h1">
            {title}
          </Typography>
        </DialogTitle>
      )}

      <DialogContent className={`${classes.dialogContent} ${dialogContentClass}`}>{children}</DialogContent>

      {closeButton && (
        <IconButton className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      )}
    </Dialog>
  );
};

export default Modal;
